import AmountType from "./AmountType";

type Props = {
  label: string;
  price: string;
  type?: string;
};

export function SummaryTable({ label, price, type = "usd" }: Props) {
  return (
    <div className="checkout-total-table">
      <span className="checkout-label-total">{label}</span>{" "}
      <span className="checkout-amount-value">{price}</span>{" "}
      <AmountType text={type} />
    </div>
  );
}
